import React from "react";
import AboutBanner from "../../assets/Company.png";

const AboutHero = () => {
  return (
    <section className="relative w-full min-h-screen overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src={AboutBanner}
          alt="About"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[color:var(--navy)]/60" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/35 to-black/70" />
      </div>

      <div className="relative z-10 flex min-h-screen items-center">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white backdrop-blur">
              About Qualityzone
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
              People-first systems
            </div>

            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
              The team behind disciplined improvement
            </h1>

            <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
              We help organizations build quality systems that actually work in the real world
              by aligning people, processes, and accountability.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#story"
                className="inline-flex items-center justify-center rounded-lg px-7 py-3 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition shadow-lg"
              >
                Our Story
              </a>
              <a
                href="#values"
                className="inline-flex items-center justify-center rounded-lg px-7 py-3 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
              >
                Our Values
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
